import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import '../_text-621010bc.js';
import { Text } from './text.js';
import { Heading } from './heading.js';

var styles = {
raw: ".hcr-img-link-1-6-0{display:block;margin-bottom:12px;border:1px solid #e1e1e1;border-radius:5px;text-decoration:none;overflow:hidden}.hcr-img-link-1-6-0:hover{-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12)}.hcr-img-link__img-wrapper-1-6-0{position:relative;min-height:200px}@media (min-width:1200px){.hcr-img-link__img-wrapper-1-6-0{min-height:160px}}.hcr-img-link__img-1-6-0{position:absolute;top:50%;left:50%;width:100%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@supports ((-o-object-fit:cover) or (object-fit:cover)){.hcr-img-link__img-1-6-0{height:100%;-o-object-fit:cover;object-fit:cover}}.hcr-img-link__content-1-6-0{position:relative;padding:12px 36px 12px 24px;background:#fff}.hcr-img-link__content-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;top:50%;right:12px;margin-top:-11px}.hcr-img-link--sm-1-6-0{position:relative;min-height:92px}.hcr-img-link--sm-1-6-0 .hcr-img-link__img-wrapper-1-6-0{position:absolute;top:0;bottom:0;left:0;width:90px;min-height:90px}.hcr-img-link--sm-1-6-0 .hcr-img-link__content-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:calc(100% - 90px);min-height:90px;margin-left:90px}",
map:{"hcr-img-link":"hcr-img-link-1-6-0","hcr-img-link__img-wrapper":"hcr-img-link__img-wrapper-1-6-0","hcr-img-link__img":"hcr-img-link__img-1-6-0","hcr-img-link__content":"hcr-img-link__content-1-6-0","hcr-img-link--sm":"hcr-img-link--sm-1-6-0"}};

var bem = Bem('img-link', styles);
var ImageLink = function ImageLink(_ref) {
  var extraClasses = _ref.extraClasses,
      href = _ref.href,
      img = _ref.img,
      title = _ref.title,
      text = _ref.text,
      small = _ref.small,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "href", "img", "title", "text", "small", "children"]);

  return React.createElement("a", _extends({
    className: bem.b({
      sm: small
    }, extraClasses),
    href: href
  }, rest), React.createElement("div", {
    className: bem.e('img-wrapper')
  }, React.createElement("img", _extends({
    className: bem.e('img')
  }, img)), " "), React.createElement("div", {
    className: bem.e('content')
  }, !title && !text && children, title && React.createElement(Heading, {
    size: 3,
    sectionHeader: text && true
  }, title), text && React.createElement(Text, {
    style: {
      marginBottom: 0
    }
  }, text)));
};
ImageLink.defaultProps = {
  extraClasses: '',
  text: null,
  small: null,
  children: null,
  title: ''
};
ImageLink.displayName = 'ImageLink';
ImageLink.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Required link */
  href: PropTypes.string.isRequired,

  /** Display a smaller version of image link */
  small: PropTypes.bool,

  /** Children to be used instead of text or title */
  children: PropTypes.node,

  /** Image configuration object */
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,

  /** Image link title */
  title: PropTypes.string,

  /** Image link text */
  text: PropTypes.string
};
var imageLink = Injecss(ImageLink, styles);

export { imageLink as ImageLink };
